import { createLoadingAnimationComponent } from '@vfde-brix-ws10/loading-animation';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix-ws10/core';
import { CONTAINER_LOADING_ANINMATION } from '../container/Ui/constants';

/**
 * Some Loading Animation
 *
 */
export const mountLoadingAnimation = () => {

    const loadingAnimation = document.getElementById(CONTAINER_LOADING_ANINMATION);

    return createLoadingAnimationComponent(loadingAnimation, {
        business: NO_PATTERN_BUSINESS_LOGIC,
    });

};
